// @flow
import $ from 'jquery'
import authenticityToken from '../shared/authenticityToken'
import { encodeUrlForBackend } from './getJson'

export function postUrl(url: string) {
  return $.post(encodeUrlForBackend(url))
}

export default function postJson(url: string, data?: Object) {
  return $.ajax({
    url: encodeUrlForBackend(url),
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify({ ...(data || {}), authenticity_token: authenticityToken() })
  })
}
